import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { getFullPath } from 'lib/location'
import ModalRouterContext from './ModalRouterContext'

import AuthLogic from 'components/Auth/AuthLogic'
import ModalRoute from './ModalRoute'

/**
 * Modal private route
 * Displays a normal ModalRoute within or under certain conditions does not render the component but a ALMA login prompt
 * @param {object} props
 * @param {function} props.render - React-router render prop - The render prop function has access to all the same route props (match, location and history) as the component render prop.
 * @param {boolean} props.loginUserSourceLabeling - Information for AuthLogic component but probably not received and undefined here
 * @param {React.ReactNode} props.component - Component to be rendered in this route path
 */

const ModalPrivateRoute = ({ render, loginUserSourceLabeling, component: Component, ...rest }) => {
    const { loggedIn, primaryRouteIsPrivate } = useContext(ModalRouterContext)

    return (
        <ModalRoute
            {...rest}
            render={(props) => {
                if (!loggedIn && primaryRouteIsPrivate) {
                    return null // do not render anything and let the primary route to handle login flow
                }

                return (
                    loggedIn === true
                        ? (render ? render(props) : <Component {...props} />)
                        : (
                            <AuthLogic
                                onMount={({ login }) => login({
                                    successTarget: getFullPath(props.location),
                                    userSourceLabeling: loginUserSourceLabeling,
                                })}
                            />
                        )
                )
            }}
        />
    )
}

ModalPrivateRoute.propTypes = {
    render: PropTypes.func,
    component: PropTypes.any,
    loginUserSourceLabeling: PropTypes.shape({
        source: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }),
}

export default ModalPrivateRoute
